import $ from 'jquery';
import gsap from 'gsap';

$(() =>
{
    var logo = $('figure.logo')[0];
    var navigationMain = $('nav.main')[0];
    var navigationCloseButton = $('nav.main button.close')[0];

    $([logo, navigationMain]).on("click", (event) =>
    {
        if ($(window).width()! < 783)
            if (!$(navigationMain).hasClass('open'))
            {
                event.preventDefault();

                $(navigationMain).addClass('open');
            }
    });

    $(navigationCloseButton).on('click', (event) =>
    {
        console.log('close')
        
        $(navigationMain).removeClass('open');

        event.stopPropagation();
    });
})